export default "__VITE_ASSET__CqTYCdhx__"